import { render, staticRenderFns } from "./BasicCheckbox.vue?vue&type=template&id=667813c0&scoped=true&"
import script from "./BasicCheckbox.vue?vue&type=script&lang=js&"
export * from "./BasicCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./BasicCheckbox.vue?vue&type=style&index=0&id=667813c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667813c0",
  null
  
)

export default component.exports